export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // no 0/O/1/I confusion
export const ROOM_CODE_LENGTH = 6;
export const USERNAME_RE = /^[a-zA-Z0-9_]{3,20}$/;
export const DISPLAY_NAME_MAX = 24;
export const CHAT_MAX_LENGTH = 500;
export const CHALLENGE_TTL_MS = 30_000;
export const CHALLENGE_DECLINE_LIMIT = 3;
export const CHALLENGE_BLOCK_MS = 24 * 60 * 60 * 1000;
export const WIN_RATE_MIN_GAMES = 20;
export const DEFAULT_RATING = 1200;
export const SUPPORTED_LOCALES = ['en', 'es', 'pt', 'fr', 'de', 'hi', 'ar', 'ja'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
/** Each language's name in itself, for language pickers and links. */
export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  es: 'Español',
  pt: 'Português',
  fr: 'Français',
  de: 'Deutsch',
  hi: 'हिन्दी',
  ar: 'العربية',
  ja: '日本語',
};
/** The landing page in each language, each its own crawlable URL: "/" for English, "/hi", "/es"… */
export const homePath = (l: Locale): string => (l === 'en' ? '/' : `/${l}`);
/** The language of a landing URL ("/hi" or "/hi/"), or null for "/" and every other path. */
export function localeOfHomePath(path: string): Locale | null {
  const m = /^\/([a-z]{2})\/?$/.exec(path);
  const l = m?.[1] as Locale | undefined;
  return l && l !== 'en' && SUPPORTED_LOCALES.includes(l) ? l : null;
}

/** Clans: creation cost in coins, size cap and the badges a clan can pick. */
export const CLAN_CREATE_COST = 500;
export const CLAN_MAX_MEMBERS = 30;
export const CLAN_BADGES = ['🐍', '🐉', '🦂', '🦅', '🐺', '🦁', '🔥', '⚡', '👑', '💀', '🌙', '⭐'] as const;
